import React from "react";
export const COMPANYMENU = [
    {
        title: "Inicio",
        icon: <i className="pe-7s-home pe-lg"></i>,
        type: "link",
        path: `${process.env.REACT_APP_PUBLIC_URL}/dashboard/company/default`,
        active: true,
        bookmark: false,
    },
    {
        title: "Acciones",
        icon: <i className="pe-7s-network pe-lg"></i>,
        type: "link",
        path: `${process.env.REACT_APP_PUBLIC_URL}/dashboard/company/default`,
        children: [
            { title: "Reportes", type: "sub" },
            {
                title: "Reportes de Valet",
                type: "link",
                path: `${process.env.REACT_APP_PUBLIC_URL}/pages/valetreports`,
            }
        ]
    },

]
